var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_27_1",
    "data-name": "Component 27 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "account-reactivate-outline",
    d: "M17.6,7.6h-4l1.488-1.488A6.4,6.4,0,0,0,4.912,13.88,6.729,6.729,0,0,1,10,12a6.716,6.716,0,0,1,5.088,1.88A6.356,6.356,0,0,0,16.4,10H18a8,8,0,1,1-1.776-5.024L17.6,3.6v4M10,16.4a6.337,6.337,0,0,0,4-1.408c-.512-.808-2.04-1.392-4-1.392s-3.488.584-4,1.392A6.337,6.337,0,0,0,10,16.4M10,5.2A2.8,2.8,0,1,1,7.2,8,2.8,2.8,0,0,1,10,5.2m0,1.6A1.2,1.2,0,1,0,11.2,8,1.2,1.2,0,0,0,10,6.8Z",
    transform: "translate(-2 -2)",
    fill: "#474747"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCircle);
export default __webpack_public_path__ + "static/media/accountCircle.78cf3ff8a7b7c50fe76e9717b3637635.svg";
export { ForwardRef as ReactComponent };